import naturalSort from 'javascript-natural-sort'
import type { SelectOptions } from '../types'
import type { ChartOfAccount } from '../Settings/ChartOfAccountSettings/validation'

export const createChartOfAccountsOptions = (
	chartOfAccounts: ChartOfAccount[],
): SelectOptions[] => {
	let options: SelectOptions[] = []

	if (chartOfAccounts && chartOfAccounts.length > 0) {
		options = chartOfAccounts.map((b: ChartOfAccount) => {
			return {
				label: b.name,
				value: b.uuid,
			}
		})
	}

	return options.sort((a, b) => naturalSort(a.label, b.label))
}
